import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import partial from 'lodash/partial';
import map from 'lodash/map';
import EmailField from 'account/components/email_field';
import { atAdmin } from 'common/utils';
import {
  toggleEmailNotification, updateEmailNotification, updateSettings
} from 'account/ducks/notification_settings';

export function mapStateToProps(state, { id, notification }) {
  const { notificationSettings, user } = state;
  const profileData = atAdmin(state)? state.admin.people.currentUser : user.profile_data;
  const { frequencies } = notificationSettings.options;

  const clientShow = profileData.is_client && notification.user_type.indexOf('client') !== -1;
  const creativeShow = profileData.is_creative && notification.user_type.indexOf('creative') !== -1;

  return {
    value: notificationSettings.data.email[id],
    checked: Object.keys(notificationSettings.data.email).indexOf(id) !== -1,
    shouldShow: clientShow || creativeShow,
    frequencies: map(frequencies, (freq, key) => ({ label: freq, value: key * 1 })),
  };
}

export function mapDispatchToProps(dispatch, { id }) {
  return bindActionCreators({
    onToggle: partial(toggleEmailNotification, id),
    onChange: partial(updateEmailNotification, id),
    updateSettings,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailField);



// WEBPACK FOOTER //
// ./account/containers/email_field.js